const Constants = {
  apiUrls: {
    userEmail: '/rest/invitations',
    userDetails: '/rest/invitations/',
    dashboard: '/rest/dashboard',
    usersList: '/rest/users',
    currentUser: '/rest/currentuser',
    associationsList: '/rest/associations',
    organizationList: '/rest/organizations',
    cohorts: '/rest/cohorts',
    cohortsOrgs: '/rest/cohorts/organizations',
    saveCohort: '/rest/cohorts?save=',
    cohortConfig: '/rest/cohorts/config',
    casorgs: '/rest/casorgs',
    userInstitution: '/rest/userinstitution',
    casOrganizationsData: '/rest/casdata',
    reportTicket: '/rest/reports/ticket',
    searchCas: '/rest/users/search/cas',
    searchOrgs: '/rest/users/search/clients',
    searchUserRoles: '/rest/users/search/userroles',
    searchStatuses: '/rest/users/search/statuses',
    search: '/rest/users/search',
    exportUsers: '/rest/users/search/export',
    searchInstitutions: '/rest/users/search/institutions',
    institutions: '/rest/institutions',
    banners: '/rest/banners',
    adminBanners: '/rest/admin/banners',
    associationSpecialty: '/rest/associations/associationSpecialty',
    superUserSpeciality: '/rest/users/userSpecialty',
  },
  formatDate: 'MMM DD, YYYY h:mm a',
  saveFormat: 'yyyy-MM-dd HH:mm:ss',
  defaultPageTitle: 'Liaison Analytics',
  userListSearchInputDebounceMs: 1000,
  userListDefaultPageSize: 25,
  layoutGridSize: 12,
  formLabelSize: 4,
  formLabelSizeSm: 2,
};

export default Constants;
